import { gql } from '@apollo/client';

import ApplicationNote from 'src/views-new/ApplicationDetailsTaskView/CandidateSecondaryContent/InternalNoteSection/ApplicationNote';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const JobStageFragment = gql`
  fragment JobStageFragment on JobStage {
    id
    name
    jobId
    schedulable
    atsId
    index
  }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CandidateDetailsQuery = gql`
  ${ApplicationNote.fragments.application}
  query CandidateDetails($id: uuid!) {
    candidate(id: $id) {
      id
      fullName
      lastActivityAt
      email
      familyName
      givenName
      atsId
      atsType
      atsCandidate {
        atsId
        atsUrl
        atsFields {
          ... on LeverCandidate {
            __typename
            origin
          }
        }
      }
      linkedinUrl
      phoneNumbers
      pronoun
      timezone
      updatedAt
      additionalEmails
      applications {
        id

        existingConversations(input: { isCancelled: false }) {
          id
          remoteId
          remoteName
          isArchived
        }
        job {
          id
          name
          atsId
          atsType
          location
          jobStagesAggregate
          sourcers {
            id
            fullName
            internalProfilePictureUrl
          }
          hiringManagers {
            id
            fullName
            internalProfilePictureUrl
          }
        }
        jobStage {
          id
          name
          jobId
          schedulable
          atsId
          index
        }
        applicationStages(input: { orderBy: { createdAt: DESC }, isCancelled: false }) {
          id
          startAt
          endAt
          createdAt
          updatedAt
          name
          timezone
          selfScheduleOptionsId
          jobStageId
          creator {
            id
            fullName
          }
          jobStage {
            id
            name
            index
          }
          isHoldForRsvp
          isReadyForCandidateComms
          hasCandidateTentative
          hasInterviewerTentative
          isCancelled
          hasCandidateDeclined
          hasInterviewerDeclined
          applicationStageCandidateEvents(input: { orderBy: { createdAt: DESC } }) {
            id
            startAt
            endAt
            responseStatus
            googleEventUrl
            isCancelled
            name
            googleEventId
            googleCalendarId
          }
          applicationStageInterviews(input: { orderBy: { startAt: ASC }, isCancelled: false }) {
            id
            startAt
            endAt
            name
            calendarEventTitle
            isCancelled
            googleEventId
            googleEventUrl
            googleCalendarId
            applicationStageInterviewInterviewers {
              role
              isOptional
              interviewerId
              responseStatus
              applicationStageInterviewId
              interviewer {
                id
                internalProfilePictureUrl
                fullName
              }
            }
            applicationStageInterviewRooms {
              applicationStageInterviewId
              meetingRoomId
              responseStatus
              meetingRoom {
                id
                name
              }
            }
          }
          selfScheduleOptionsId
        }
        applicationDebriefs(input: { orderBy: { createdAt: DESC }, isCancelled: false }) {
          id
          startAt
          endAt
          isCancelled
          isPrivateCalendarEvent
          attendees {
            interviewerId
            responseStatus
            interviewer {
              id
              fullName
              email
              internalProfilePictureUrl
            }
            isOptional
          }
          meetingRooms {
            applicationDebriefId
            meetingRoomId
            responseStatus
          }
        }
        status
        state {
          isSchedulable
          isNotScheduleable
          isUnscheduled
          isAvailabilityRequested
          isReadyToSchedule
          isCanceled
          isOngoing
          isScheduled
          isCompleted
          isScheduledInAts
          isCompletedInAts
          isCandidateDeclined
          isInterviewerDeclined
          isSelfScheduleRequested
          isHoldForRsvp
          isReadyForCandidateComms
        }
        upcomingApplicationStage {
          id
          startAt
          endAt
          selfScheduleOptionsId
          minStartAt
          applicationStageInterviews(input: { orderBy: { startAt: ASC }, isCancelled: false }) {
            id
            startAt
            endAt
          }
        }
        ...ApplicationNote_application
      }
    }
  }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const JobStageDetails = gql`
  query JobStageDetails($input: JobStagesInput!) {
    jobStages(input: $input) {
      items {
        ...JobStageFragment
      }
    }
  }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const JobStageUpdatedAt = gql`
  query JobStageUpdatedAt($id: uuid!) {
    jobStage(id: $id) {
      id
      updatedAt
    }
  }
`;

export const CandidateAvailabilityFragment = gql`
  fragment CandidateAvailabilityFragment on CandidateAvailability {
    id
    createdAt
    updatedAt
    candidateEnteredAvailability {
      startAt
      endAt
    }
    rcEnteredAvailability {
      startAt
      endAt
    }
    lastUpdatedByEmployeeId
    lastUpdatedByEmployee {
      id
      fullName
    }
    employeeUpdatedAt
    candidateUpdatedAt
  }
`;

// Used in Schedule Flow
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const GQLConfidentialJobFromJobStage = gql`
  query ConfidentialJobByJobStage($id: uuid!) {
    jobStage(id: $id) {
      job {
        isConfidential
        id
      }
    }
  }
`;

// Used in Debrief flow
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const GQLConfidentialJobFromApplication = gql`
  query ConfidentialJobByApplication($id: uuid!) {
    application(id: $id) {
      job {
        isConfidential
        id
      }
    }
  }
`;
